import { useMutation, UseMutationOptions } from 'react-query';
import { mutateIgnoreWinterSettlement } from './setIgnoreWinterSettlement';
import { TIgnoreWinterSettlementBody } from './setIgnoreWinterSettlement.types';

export const useMutationIgnoreWinterSettlementSport = (
  options?: UseMutationOptions<unknown, unknown, TIgnoreWinterSettlementBody>
) => useMutation((data) => mutateIgnoreWinterSettlement(data), options);
